import { useState } from "react";
import { useData } from "../contexts/DataContext";
import CalendarView from "../components/views/CalendarView";
import TaskDialog from "../components/TaskDialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function GlobalCalendar() {
  const { tasks, projects, setOpenTaskId } = useData();
  const [dialog, setDialog] = useState(null);
  const [projectId, setProjectId] = useState("all");

  const scoped = projectId === "all" ? tasks : tasks.filter((t) => t.project_id === projectId);

  return (
    <div className="p-4 md:p-6" data-testid="global-calendar-page">
      <div className="flex items-center gap-3 mb-4">
        <h2 className="font-heading text-xl font-bold tracking-tight">All tasks by due date</h2>
        <div className="ml-auto">
          <Select value={projectId} onValueChange={setProjectId}>
            <SelectTrigger data-testid="calendar-project-filter" className="h-8 w-44 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All projects</SelectItem>
              {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <CalendarView tasks={scoped}
        onOpenTask={(t) => setOpenTaskId(t.id)}
        onAddTask={(dateKey) => {
          const pid = projectId !== "all" ? projectId : projects[0]?.id;
          if (pid) setDialog({ projectId: pid, dueDate: dateKey });
        }} />
      {dialog && (
        <TaskDialog open onClose={() => setDialog(null)} projectId={dialog.projectId} defaultDueDate={dialog.dueDate} />
      )}
    </div>
  );
}
